import React from "react";
import styles from "./BotonSkills.module.scss";
import { connect } from "react-redux";
import { addSkill, removeSkill } from "../../../store/actions/index";

const BotonSkills = ({
  children,
  skillSelected,
  id,
  addSkill,
  removeSkill,
}) => {
  return (
    <div
      key={id}
      className={`${styles.btn} ${skillSelected ? styles.selectedSkill : ""}`}
      onClick={() => (skillSelected ? removeSkill(id) : addSkill(id))}>
      {children}
    </div>
  );
};

export default connect(null, { addSkill, removeSkill })(BotonSkills);
